export enum ChartEnum {
  termFactor = 'Factor AVG',
  daily = 'Daily',
  paidOffAvg = 'Paid Off AVG',
  pnl = 'PNL',
}

export type ChartEnumKey = 'termFactor' | 'daily' | 'paidOffAvg' | 'pnl'
